import React from "react";
import {
  Facebook,
  Twitter,
  Instagram,
  Linkedin,
  Mail,
  Phone,
  MapPin,
} from "lucide-react";
import logo from "../Images/logo.png";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer className="relative bg-gradient-to-br from-slate-950 via-slate-900 to-slate-950 text-white overflow-hidden">
      <div className="absolute inset-0 opacity-5">
        <div className="absolute inset-0 bg-[linear-gradient(rgba(255,255,255,0.05)_1px,transparent_1px),linear-gradient(90deg,rgba(255,255,255,0.05)_1px,transparent_1px)] bg-[size:50px_50px]"></div>
      </div>

      <div className="absolute top-0 right-0 w-96 h-96 bg-gradient-to-br from-pink-600/10 to-transparent rounded-full blur-3xl"></div>
      <div className="absolute bottom-0 left-0 w-96 h-96 bg-gradient-to-tr from-indigo-600/10 to-transparent rounded-full blur-3xl"></div>

      <div className="relative max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          <div className="space-y-6">
            <div className="group cursor-pointer">
              <img
                style={{ height: "3rem", width: "11rem" }}
                alt=""
                src={logo}
              />
            </div>

            <p className="text-gray-400 leading-relaxed text-sm">
              Empowering India to transact through Digital Banking. Our better
              Investment Decisions make Customers Happy.
            </p>

            <div className="flex gap-3">
              <a
                href="https://www.facebook.com/Bumppy%20Paymentsments?mibextid=ZbWKwL"
                className="w-10 h-10 rounded-full bg-white/5 border border-white/10 flex items-center justify-center hover:bg-gradient-to-r hover:from-blue-600 hover:to-blue-700 hover:border-blue-500 transition-all duration-300 hover:scale-110 hover:shadow-lg hover:shadow-blue-500/50 group"
                aria-label="Facebook"
              >
                <Facebook className="w-5 h-5 text-gray-400 group-hover:text-white transition-colors" />
              </a>
              <a
                href="https://x.com/BumppyOfficial?t=mwRTh4QryiIIdFvIayKyew&s=08"
                className="w-10 h-10 rounded-full bg-white/5 border border-white/10 flex items-center justify-center hover:bg-gradient-to-r hover:from-blue-400 hover:to-blue-500 hover:border-blue-400 transition-all duration-300 hover:scale-110 hover:shadow-lg hover:shadow-blue-400/50 group"
                aria-label="Twitter"
              >
                <Twitter className="w-5 h-5 text-gray-400 group-hover:text-white transition-colors" />
              </a>
              <a
                href="https://www.instagram.com/Bumppy_Payments/"
                className="w-10 h-10 rounded-full bg-white/5 border border-white/10 flex items-center justify-center hover:bg-gradient-to-r hover:from-pink-600 hover:to-purple-600 hover:border-pink-500 transition-all duration-300 hover:scale-110 hover:shadow-lg hover:shadow-pink-500/50 group"
                aria-label="Instagram"
              >
                <Instagram className="w-5 h-5 text-gray-400 group-hover:text-white transition-colors" />
              </a>
              <a
                href="https://www.linkedin.com/company/Bumppy/"
                className="w-10 h-10 rounded-full bg-white/5 border border-white/10 flex items-center justify-center hover:bg-gradient-to-r hover:from-blue-700 hover:to-blue-800 hover:border-blue-600 transition-all duration-300 hover:scale-110 hover:shadow-lg hover:shadow-blue-700/50 group"
                aria-label="LinkedIn"
              >
                <Linkedin className="w-5 h-5 text-gray-400 group-hover:text-white transition-colors" />
              </a>
            </div>
          </div>

          <div>
            <h3 className="text-lg font-bold mb-6 text-white relative inline-block">
              Company
              <span className="absolute -bottom-2 left-0 w-12 h-0.5 bg-gradient-to-r from-pink-500 to-orange-500"></span>
            </h3>
            <ul className="space-y-3">
              <li>
                <Link
                  to="/about"
                  className="text-gray-400 hover:text-white hover:translate-x-2 inline-block transition-all duration-300 text-sm group relative"
                >
                  <span className="relative z-10">About Us</span>
                  <span className="absolute inset-0 w-0 bg-gradient-to-r from-pink-500/10 to-transparent group-hover:w-full transition-all duration-300 -z-0"></span>
                </Link>
              </li>
              <li>
                <Link
                  to="/pricing"
                  className="text-gray-400 hover:text-white hover:translate-x-2 inline-block transition-all duration-300 text-sm group relative"
                >
                  <span className="relative z-10">Our Pricing</span>
                  <span className="absolute inset-0 w-0 bg-gradient-to-r from-pink-500/10 to-transparent group-hover:w-full transition-all duration-300 -z-0"></span>
                </Link>
              </li>
              <li>
                <Link
                  to="/contact"
                  className="text-gray-400 hover:text-white hover:translate-x-2 inline-block transition-all duration-300 text-sm group relative"
                >
                  <span className="relative z-10">Contact</span>
                  <span className="absolute inset-0 w-0 bg-gradient-to-r from-blue-500/10 to-transparent group-hover:w-full transition-all duration-300 -z-0"></span>
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-lg font-bold mb-6 text-white relative inline-block">
              Support
              <span className="absolute -bottom-2 left-0 w-12 h-0.5 bg-gradient-to-r from-blue-500 to-indigo-500"></span>
            </h3>
            <ul className="space-y-3">
              <li>
                <Link
                  to="/refund"
                  className="text-gray-400 hover:text-white hover:translate-x-2 inline-block transition-all duration-300 text-sm group relative"
                >
                  <span className="relative z-10">Refund & Cancellation</span>
                  <span className="absolute inset-0 w-0 bg-gradient-to-r from-blue-500/10 to-transparent group-hover:w-full transition-all duration-300 -z-0"></span>
                </Link>
              </li>
              <li>
                <Link
                  to="/faq"
                  className="text-gray-400 hover:text-white hover:translate-x-2 inline-block transition-all duration-300 text-sm group relative"
                >
                  <span className="relative z-10">FAQ's</span>
                  <span className="absolute inset-0 w-0 bg-gradient-to-r from-blue-500/10 to-transparent group-hover:w-full transition-all duration-300 -z-0"></span>
                </Link>
              </li>
              <li>
                <Link
                  to="/privacy"
                  className="text-gray-400 hover:text-white hover:translate-x-2 inline-block transition-all duration-300 text-sm group relative"
                >
                  <span className="relative z-10">Privacy Policy</span>
                  <span className="absolute inset-0 w-0 bg-gradient-to-r from-blue-500/10 to-transparent group-hover:w-full transition-all duration-300 -z-0"></span>
                </Link>
              </li>
              <li>
                <Link
                  to="/terms"
                  className="text-gray-400 hover:text-white hover:translate-x-2 inline-block transition-all duration-300 text-sm group relative"
                >
                  <span className="relative z-10">Terms & Condition</span>
                  <span className="absolute inset-0 w-0 bg-gradient-to-r from-blue-500/10 to-transparent group-hover:w-full transition-all duration-300 -z-0"></span>
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-lg font-bold mb-6 text-white relative inline-block">
              Address
              <span className="absolute -bottom-2 left-0 w-12 h-0.5 bg-gradient-to-r from-emerald-500 to-teal-500"></span>
            </h3>
            <div className="space-y-4">
              <div className="group">
                <div className="flex items-start gap-3 p-3 rounded-lg hover:bg-white/5 transition-all duration-300">
                  <MapPin className="w-5 h-5 text-emerald-400 flex-shrink-0 mt-0.5 group-hover:scale-110 transition-transform" />
                  <div className="text-sm">
                    <p className="text-white font-semibold mb-1">
                      BUMPPY PAYMENTS PVT LTD
                    </p>
                    <p className="text-gray-400 leading-relaxed">
                      B-218 Ithum Tower
                      <br />
                      Second Floor
                      <br />
                      Sector-62, Noida, 201301
                    </p>
                  </div>
                </div>
              </div>

              <a
                href="mailto:support@bumppy.com"
                className="flex items-center gap-3 p-3 rounded-lg hover:bg-white/5 transition-all duration-300 group"
              >
                <Mail className="w-5 h-5 text-blue-400 flex-shrink-0 group-hover:scale-110 transition-transform" />
                <span className="text-gray-400 text-sm group-hover:text-white transition-colors">
                  support@bumppy.com
                </span>
              </a>

              <a
                href="tel:+918130096176"
                className="flex items-center gap-3 p-3 rounded-lg hover:bg-white/5 transition-all duration-300 group"
              >
                <Phone className="w-5 h-5 text-pink-400 flex-shrink-0 group-hover:scale-110 transition-transform" />
                <div className="text-sm">
                  <p className="text-gray-400 group-hover:text-white transition-colors">
                    Phone: +91 81-300-96176
                  </p>
                  <p className="text-gray-400 group-hover:text-white transition-colors">
                    Fax: +91 81-300-96176
                  </p>
                </div>
              </a>
            </div>
          </div>
        </div>

        <div className="pt-8 border-t border-white/10">
          <div className="flex flex-col md:flex-row justify-center items-center gap-4">
            <p className="text-gray-400 text-sm">
              © 2025 Bumppy - All rights Reserved
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
